import { createBrowserClient } from "@supabase/ssr";
import { env } from "~/env";

export function createClient() {
  return createBrowserClient(
    env.NEXT_PUBLIC_SUPABASE_URL,
    env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY,
    {
      // OAuth code exchange runs on the ephemeral signup client (see
      // src/lib/auth/client.ts), so the persistent cookie client must NOT
      // auto-consume the `?code=` on /auth/callback and race with it.
      auth: { detectSessionInUrl: false },
    },
  );
}
